<template>
    <v-container
      fluid
      class="secondary fill-height"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="6">
          <!-- login card -->
          <v-card
            rounded="lg"
            class="pa-5"
          >
            <!-- login form -->
            <v-form @submit.prevent="login">
              <div class="primary--text text-md-center font-weight-bold text-h5">
                Validating
              </div>
            </v-form>
          </v-card>
          <!-- loading prompt -->
          <v-progress-linear
            color="primary"
            indeterminate
            :active="loading"
          ></v-progress-linear>
        </v-col> 
      </v-row>
    </v-container>
  </template>
  
<script>
import API from "@/api";
const User = API.get("User");
export default {
  name: "Callback",
  data: () => ({
    loading: false
  }),
  mounted() {
    this.processParams();
  },
  methods: {
    async processParams() {
        this.loading = true;
      let params = window.location.hash.replace("#", "").split("&");
      let data = {};

      localStorage.removeItem('login_session_key');

      for (let i in params) {
        let row = params[i].split("=");
        data[row[0]] = row[1];
      }

      let form = new FormData(this.$refs.callbackForm);
      for (let n in data) {
        form.append(n, data[n]);
      }

      form.append("type", "api");

      var response = await User.msProcessResponse(form);
      if (response.status == 200) {
        this.loading = false;
        this.$store.dispatch("profile/signIn", {
          user: response.data.user,
          token: response.data.token.accessToken,
        });
      }
    },
  },
};
</script>
